export enum UserRole {
    User = 'User',
    Family = 'Family',
    Friend = 'Friend',
    Admin = 'Admin',
    None = 'None'
}